import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerTitle,
} from "@/components/ui/drawer";
import Icon from "@/components/icon";
import {
  EITAA_BASE_URL,
  SUPPORT_EITAA_USERNAME,
  SUPPORT_PHONE,
} from "@/utils/constant";

interface EducatorsSupportDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function EducatorsSupportDrawer({
  open,
  onOpenChange,
}: EducatorsSupportDrawerProps) {
  const supportUsername = SUPPORT_EITAA_USERNAME.replace(/^@/, "");
  const supportChatLink = `${EITAA_BASE_URL}/${supportUsername}`;
  const supportPhone = SUPPORT_PHONE.replace(/[^\d+]/g, "");

  const options = [
    {
      key: "chat",
      href: supportChatLink,
      external: true,
      icon: "support",
      iconClass: "bg-primary/10 text-primary",
      label: "گفتگو با پشتیبانی",
      value: `@${supportUsername}`,
    },
    {
      key: "call",
      href: `tel:${supportPhone}`,
      external: false,
      icon: "support-phone",
      iconClass: "bg-success/10 text-success",
      label: "تماس با پشتیبانی",
      value: SUPPORT_PHONE,
    },
  ] as const;

  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent className="px-5 pb-2">
        <div className="mb-5 flex flex-col">
          <DrawerTitle className="text-base">ارتباط با پشتیبانی</DrawerTitle>
          <DrawerDescription className="mt-1">
            روش ارتباط را انتخاب کنید
          </DrawerDescription>
        </div>

        <div className="flex flex-col gap-2">
          {options.map((option) => (
            <a
              key={option.key}
              href={option.href}
              {...(option.external
                ? { target: "_blank", rel: "noopener noreferrer" }
                : {})}
              onClick={() => onOpenChange(false)}
              className="group flex items-center gap-3 rounded-2xl bg-content2 p-3 transition active:scale-[0.98]"
            >
              <span
                className={`flex size-10 shrink-0 items-center justify-center rounded-xl ${option.iconClass}`}
              >
                <Icon name={option.icon} size={20} />
              </span>

              <span className="flex min-w-0 flex-1 flex-col text-right">
                <span className="text-sm font-semibold text-foreground">
                  {option.label}
                </span>
                <span
                  dir="ltr"
                  className="mt-0.5 truncate text-xs text-default-400 text-right"
                >
                  {option.value}
                </span>
              </span>

              <Icon
                name="chevron-left"
                size={18}
                className="shrink-0 text-default-300"
              />
            </a>
          ))}
        </div>
      </DrawerContent>
    </Drawer>
  );
}
